/// <amd-module name="WidgetCommon/WorkItemResultsGrid/WorkItemResultsDataProvider" />
import { WorkItemTypeColorAndIcon } from "Dashboards/Clients/Contracts/WorkItemTracking";
import * as Resources from "WidgetCommon/WorkItemResultsGrid/Resources";
import { WorkItemId } from "Wit/UI/Client";
import { IPagedWorkItemsList, WorkItemTrackingDataProvider } from "Wit/UI/Data";
import { DEFAULT_WORKITEMTYPE_COLOR_AND_ICON } from "Wit/UI/WorkItemTypeIcon";

export class WorkItemResultsDataProvider extends WorkItemTrackingDataProvider {
    private pagedWorkItemsList: IPagedWorkItemsList;
    private initialKey: string;

    /**
     * The parent class, WorkItemTrackingDataProvider, creates a new
     * PagedWorkItemsList every time it is called. In our case,
     * we need to use the PagedWorkItemsList twice - once in
     * WorkItemResultsGrid and once in WorkItemGrid. If we didn't
     * store the PagedWorkItemsList here for the initial creation, we would be creating
     * two separate PageWorkItemsLists and would end up requesting the same
     * data twice.
     * @param source
     * @param pageSize
     */
    public getPagedWorkItemsList(workItemIds: WorkItemId[], pageSize?: number): IPagedWorkItemsList {
        if (!this.pagedWorkItemsList || !this.initialKey) {
            this.pagedWorkItemsList = super.getPagedWorkItemsList(workItemIds, pageSize || undefined);
            this.initialKey = JSON.stringify(workItemIds);
            return this.pagedWorkItemsList;
        } else {
            const newKey = JSON.stringify(workItemIds);
            if (newKey === this.initialKey) {
                return this.pagedWorkItemsList;
            }
        }

        return super.getPagedWorkItemsList(workItemIds, pageSize || undefined);
    }

    public getWorkItemTypeColorAndIcon(
        projectIdOrName: string,
        workItemTypeName: string
    ): Promise<Readonly<WorkItemTypeColorAndIcon>> | Readonly<WorkItemTypeColorAndIcon> {
        if (workItemTypeName === Resources.WorkItemTypeFilter_OtherBucketLabel) {
            return this.getOtherBucketColorAndIcon();
        }

        return super.getWorkItemTypeColorAndIcon(projectIdOrName, workItemTypeName);
    }

    public getOtherBucketColorAndIcon(): Readonly<WorkItemTypeColorAndIcon> {
        return {
            icon: DEFAULT_WORKITEMTYPE_COLOR_AND_ICON.icon,
            color: "#777777",
            workItemTypeName: Resources.WorkItemTypeFilter_OtherBucketLabel,
            isDisabled: false
        };
    }
}
